const analyticsService = {
  pushPageView: (screenName, params = {}) => {
    window.dataLayer?.push({ event: 'page_view', screen_name: screenName, ...params });
  },
  pushEvent: (eventName, params = {}) => {
    window.dataLayer?.push({ event: eventName, ...params });
  },
};

export default analyticsService;
